<template>
  <div class="w-full h-auto py-[3.75vw] bg-[#F5F5F7]">
    <div
      class="relative mx-auto w-[61.46vw] h-[25.31vw] px-[2.5vw] py-[3.96vw] bg-white rounded-xl flex justify-between"
    >
      <!-- 文字区域 -->
      <div class="relative w-auto py-[0.75vw] flex flex-col justify-between">
        <!-- 文字区域-上 -->
        <div
          class="flex items-start justify-start gap-[1.4vw] relative w-auto h-auto"
        >
          <i class="el-icon-map-location text-[2.08vw]"></i>
          <div class="flex flex-col items-start gap-[0.5vw]">
            <div
              class="text-start text-[#05358c] text-[1.04vw] font-medium font-harmony"
            >
              总部联系
            </div>
            <div class="flex flex-col w-full">
              <div
                class="w-full h-0 bg-[#05358c] outline outline-[0.50px] outline-offset-[-0.25px] outline-[#d9d9d9]"
              ></div>
              <div
                class="w-[16%] h-0 bg-[#05358c] outline outline-1 outline-offset-[-0.50px] outline-[#05358c]"
              ></div>
            </div>
            <div
              class="text-start text-[#1a2233] text-[0.94vw] font-normal font-harmony"
            >
              西安市沣东新城沣东大道2196号沣东自贸新天地文创街区2C
            </div>
            <div
              class="text-start text-[#1a2233] text-[0.94vw] font-normal font-harmony"
            >
              联系电话：400 0336 691
            </div>
          </div>
        </div>
        <!-- 文字区域-下 -->
        <div
          class="flex items-start justify-start gap-[1.4vw] relative w-auto h-auto"
        >
          <i class="el-icon-connection text-[2.08vw]"></i>
          <div class="flex flex-col items-start gap-[0.5vw]">
            <div
              class="text-start text-[#05358c] text-[1.04vw] font-medium font-harmony"
            >
              商务合作
            </div>
            <div class="flex flex-col w-full">
              <div
                class="w-full h-0 bg-[#05358c] outline outline-[0.50px] outline-offset-[-0.25px] outline-[#d9d9d9]"
              ></div>
              <div
                class="w-[28%] h-0 bg-[#05358c] outline outline-1 outline-offset-[-0.50px] outline-[#05358c]"
              ></div>
            </div>
            <div class="flex flex-row gap-[0.5vw]">
              <div class="w-auto text-[#1a2233] text-[0.94vw] font-harmony">
                <div class="flex justify-between w-full">
                  <span>刘</span>
                  <span>老</span>
                  <span>师:</span>
                </div>
                <div class="flex justify-between w-full">
                  <span>联</span>
                  <span>系</span>
                  <span>邮</span>
                  <span>箱:</span>
                </div>
              </div>
              <div
                class="text-start text-[#1a2233] text-[0.94vw] font-normal font-harmony"
              >
                18066840996<br />
                19282958807@163.com
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 图片区域 -->
      <!--<div
        class="w-[24.48vw] h-[17.19vw] flex items-center justify-end overflow-hidden rounded shadow-lg"
      >
        <el-image
          class="w-full h-full object-cover"
          :src="require('@/assets/images/ContactUs/module2/sample1.png')"

          alt="背景图"
        />
      </div>-->
        <AMapsearch></AMapsearch>

    </div>
  </div>
</template>

<script>
// import AMapsearch from '@/components/Map/map.vue'
export default {
  name: "contactus-module2",
  data() {
    return {};
  },components:{
        AMapsearch:() => import('@/components/Map/map.vue')
    }
};
</script>

<style scoped>
</style>
